import { useSelector } from "react-redux";


const IphoneTerminalLogs = () => {
    return (
        <>
            {/* <h4 style={{ "text-align": "center", "padding-bottom": "20px" }}>I phone Terminal Logs</h4> */}
            <div className="iframe-div">
                <iframe title="Report Section" width="600" height="373.5" src="https://iiplwork.retool.com/embedded/public/131bbf66-01ec-47b5-b14f-de9f42b4188f" frameborder="0" allowFullScreen="true"></iframe>
            </div>
        </>
    )
};

export default IphoneTerminalLogs;